(function () {
  'use strict';

  var NOTE_START = '[CUSTOM COLOR DETAILS]';
  var LAST_CART_TOKEN_KEY = 'rk_kca_last_cart_token_v2';

  function cartUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + path.replace(/^\//, '');
  }

  function getFields() {
    return Array.prototype.slice.call(
      document.querySelectorAll('#Cart-note, #CartDrawer-Note, textarea[name="note"]')
    );
  }

  function stripLegacyGeneratedContent(value) {
    var text = String(value || '');
    var markerMatch = /\[CUSTOM\s+COL(?:OR)?(?:\s+DETAILS)?/i.exec(text);
    var firstGeneratedIndex = markerMatch ? markerMatch.index : -1;

    // In the old implementation generated details were always appended after the
    // customer's manual note. Keeping everything before the first marker safely
    // removes complete, duplicated and even partially-corrupted generated blocks
    // such as "[CUSTOM COL" left behind by overlapping cart updates.
    if (firstGeneratedIndex !== -1) {
      return text.slice(0, firstGeneratedIndex).trim();
    }

    return text.trim();
  }

  function setFieldValues(value) {
    getFields().forEach(function (field) {
      if (field.value === value) return;
      field.value = value;
      field.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  function updateCartNote(value) {
    setFieldValues(value);

    return fetch(cartUrl('/cart/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ note: value })
    }).catch(function () {});
  }

  function addClearButton() {
    var field = document.querySelector('#Cart-note');
    if (!field || document.querySelector('.rk-note-tools')) return;

    var tools = document.createElement('div');
    tools.className = 'rk-note-tools';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'rk-note-clear';
    button.textContent = 'Clear special instructions';
    button.addEventListener('click', function () {
      updateCartNote('');
    });

    tools.appendChild(button);
    var container = field.closest('cart-note') || field.parentNode;
    if (container) container.appendChild(tools);
  }

  function cleanCartNoteLifecycle() {
    fetch(cartUrl('/cart.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var currentToken = String(cart && cart.token || '');
        var itemCount = Number(cart && cart.item_count || 0);
        var currentNote = String(cart && cart.note || '');
        var cleanNote = stripLegacyGeneratedContent(currentNote);
        var lastToken = '';

        try { lastToken = localStorage.getItem(LAST_CART_TOKEN_KEY) || ''; } catch (e) {}

        var newCart = !!(lastToken && currentToken && lastToken !== currentToken);
        var nextNote = cleanNote;

        // Empty/new carts must never inherit an old order note.
        if (itemCount === 0 || newCart) nextNote = '';

        if (nextNote !== currentNote) updateCartNote(nextNote);
        else setFieldValues(nextNote);

        try {
          if (currentToken) localStorage.setItem(LAST_CART_TOKEN_KEY, currentToken);
        } catch (e) {}
      })
      .catch(function () {});
  }

  function init() {
    if (window.location.pathname.startsWith('/cart')) addClearButton();
    cleanCartNoteLifecycle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
